<template>
  <div style="background: #F9F9FA;">
    <div class="content-box competition-banner">
      <div class="content-detail">
        <p class="title">大型赛事</p>
        <p class="text">具备丰富实践经验，提供定制影像考核系统，助力赛事组织精准高效</p>
        <p class="text">联系我们：15315145064</p>
        <button class="btn">立即加入</button>
      </div>
    </div>
    <div class="content-box tabs-content">
      <div class="content-detail">
        <ul class="tabs">
          <li class="li" :class="{'active': tabIndex === item.id}" v-for="(item, index) in tabList" :key="index" @click="tabClick(item)">{{item.name}}</li>
        </ul>
      </div>
    </div>
    <div class="content-box team-content">
      <div class="content-detail">
        <el-carousel :interval="5000" height="324px" arrow="always" class="show-carousel" v-if="competitionList1.length && !tabIndex" indicator-position="none">
          <el-carousel-item v-for="(item, index) in competitionList1" :key="index">
            <a :href="item.url?item.url:'javascript:;'" :target="item.url?'_blank':''">
              <div class="show">
                <el-carousel :autoplay="false" arrow="never" class="competition-carousel-1" height="324px" v-if="item.img.length" :indicator-position="item.img.length === 1 ? 'none' : ''">
                  <el-carousel-item v-for="(item1, index1) in item.imgList" :key="index1">
                    <img :src="`${item1.imgUrl}`"/>
                  </el-carousel-item>
                </el-carousel>
                <p class="competition">{{item.title}}</p>
                <div class="tag-box" v-if="!item.isStart">
                  <span class="tag begin">即将开始</span>
                </div>
                <div class="competition-content" v-html="item.content"></div>
                <p class="info">{{getDate(item.competitionTime)}}<span class="border"></span>{{item.competitionSite}}</p>
              </div>
            </a>
          </el-carousel-item>
        </el-carousel>
        <ul class="competition-list">
          <li class="li" :class="{'margin24': (index + 1) % 3 !== 0}" v-for="(item, index) in competitionList" :key="index">
            <a :href="item.url?item.url:'javascript:;'" :target="item.url?'_blank':''">
              <el-carousel :autoplay="false" arrow="never" class="competition-carousel-2" height="216px" v-if="item.img.length" :indicator-position="item.img.length === 1 ? 'none' : ''">
                <el-carousel-item v-for="(item1, index1) in item.imgList" :key="index1">
                  <img :src="`${item1.imgUrl}`"/>
                </el-carousel-item>
              </el-carousel>
              <p class="title"><span class="margin">{{item.title}}</span><span v-if="typeArr[item.type]" class="level" :class="typeArr[item.type].cls">{{typeArr[item.type].name}}</span></p>
              <p class="info">{{item.content}}</p>
            </a>
          </li>
        </ul>
        <div class="more" v-show="competitionList.length < allCompetitionList.length">
          <button @click="getMore">了解更多<i class="el-icon-arrow-right i1"></i><i class="el-icon-arrow-right i2"></i><i class="el-icon-arrow-right i3"></i></button>
        </div>
      </div>
      <div class="empty" v-show="!allCompetitionList.length">
        <img src="/static/img/empty.png">
        <p>没有更多了~</p>
      </div>
    </div>
  </div>
</template>

<script>
import { officialSiteServer } from '@/api/api'
import getImgUrl from '@/mixin/getImgUrl.js'
export default {
  name: 'competition',
  mixins: [getImgUrl],
  data () {
    return {
      tabList: [
        { name: '全部', id: '' },
        { name: '国家级', id: '1' },
        { name: '省级', id: '2' },
        { name: '市级', id: '7' },
        { name: '医院', id: '3' },
        { name: '院校', id: '4' },
        { name: '其他', id: '5' }
      ],
      tabIndex: '',
      allCompetitionList: [],
      competitionIndex: 0,
      competitionList: [],
      competitionList1: [],
      typeArr: {
        1: { name: '国家级', cls: 'color1' },
        2: { name: '省级', cls: 'color2' },
        7: { name: '市级', cls: 'color4' },
        3: { name: '医院', cls: '' },
        4: { name: '院校', cls: 'color3' }
      }
    }
  },
  beforeDestroy () {
  },
  mounted () {
    this.readDetail()
  },
  methods: {
    tabClick (item) {
      if (this.typeIndex === item.id) return
      this.tabIndex = item.id
      this.readDetail()
    },
    readDetail () {
      this.competitionList = []
      this.competitionList1 = []
      this.allCompetitionList = []
      officialSiteServer.queryCompetition({
        type: this.tabIndex
      }).then((res) => {
        let { code, data } = res
        if (code === '0') {
          data.forEach((item, index) => {
            item.img = item.img ? item.img.split(',') : []
            item.imgList = []
            item.img.forEach(e => {
              item.imgList.push({
                img: e
              })
            })
          })
          this.getMoreImgUrl(data, [
            { name: 'imgList', attr: 'img' }
          ]).then(() => {
            data.forEach((item, index) => {
              if (!item.isStart) {
                this.competitionList1.push(item)
              } else {
                this.allCompetitionList.push(item)
              }
              if (!this.tabIndex && this.competitionList1.length) {
                this.competitionList = this.allCompetitionList.slice(0, 3)
                this.competitionIndex = 3
              } else {
                this.competitionList = this.allCompetitionList.slice(0, 6)
                this.competitionIndex = 6
              }
            })
          })
        }
      })
    },
    getDate (time) {
      let date, y, m, d
      date = new Date(time)
      y = date.getFullYear()
      m = dateAddZero(date.getMonth() + 1)
      d = dateAddZero(date.getDate())
      function dateAddZero (num) {
        return num < 10 ? '0' + num : num
      }
      return `${y}年${m}月${d}日`
    },
    getMore () {
      if (this.allCompetitionList.length > this.competitionList.length) {
        this.competitionIndex += 6
        if (this.allCompetitionList.length > this.competitionIndex) {
          this.competitionList = this.allCompetitionList.slice(0, this.competitionIndex)
        } else {
          this.competitionList = this.allCompetitionList
        }
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
@media (min-width: 1920px) {
  .competition-banner{
    background: url("/static/img/applications/competition.png") no-repeat;
  }
}
@media (max-width: 1920px) {
  .competition-banner{
    background: url("/static/img/applications/competition1.jpg") no-repeat;
  }
}
@import "~less-lib";
.competition-banner {
  height: 560px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .content-detail {
    height: 560px;
    padding-top: 102px;
    text-align: left;
  }
  .title {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 80px;
    line-height: 110px;
    color: #FFFFFF;
    letter-spacing: 7.11px;
    margin-bottom: 26px;
  }
  .text {
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 30px;
    line-height: 42px;
    color: #FFFFFF;
    letter-spacing: 2.67px;
    font-weight: 400;
  }
  .btn {
    width: 126px;
    height: 46px;
    line-height: 46px;
    background: #0C59EF;
    border-radius: 4px;
    font-family: SourceHanSansSC-Medium;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 1.42px;
    position: absolute;
    left: 0;
    bottom: 120px;
    cursor: pointer;
  }
}
.tabs-content {
  background-color: #fff;
  margin-bottom: 100px;
  .tabs {
    height: 64px;
    text-align: left;
    .li {
      display: inline-block;
      height: 64px;
      line-height: 64px;
      font-family: SourceHanSansSC-Medium;
      font-size: 14px;
      color: #000000;
      border-bottom: 1px solid #fff;
      margin-right: 50px;
      cursor: pointer;
    }
    .active {
      color: #0C59EF;
      border-bottom: 1px solid #0C59EF;
    }
  }
}
.team-content {
  .show-carousel {
    width: 1200px;
    height: 324px;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
    border-radius: 14px;
    margin-bottom: 80px;
    overflow: hidden;
    background: #FFFFFF;
  }
  .show {
    width: 1200px;
    height: 324px;
    position: relative;
    padding: 38px 0 0 606px;
    .competition-carousel-1 {
      width: 576px;
      height: 324px;
      position: absolute;
      left: 0;
      top: 0;
      img {
        width: 576px;
        height: 324px;
      }
    }
    .competition {
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      color: #000000;
      text-align: left;
      line-height: 33px;
      margin-bottom: 10px;
    }
    .competition-content {
      font-family: SourceHanSansSC-Regular;
      font-size: 18px;
      color: #666666;
      text-align: left;
      white-space: pre-wrap;
    }
    .info {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #666666;
      text-align: left;
      line-height: 20px;
      position: absolute;
      left: 606px;
      bottom: 31px;
    }
    .tag-box {
      text-align: left;
      margin-bottom: 18px;
    }
    .tag {
      padding: 5px 20px;
      display: inline-block;
      text-align: center;
      border-radius: 14px;
      font-family: SourceHanSansSC-Regular;
      margin-right: 24px;
      font-size: 14px;
    }
    .begin {
      background: #FFEDED;
      color: #E62412;
    }
    .border {
      width: 1px;
      height: 14px;
      display: inline-block;
      vertical-align: middle;
      background: #D8D8D8;
      margin: 0 12px;
    }
  }
  .competition-list {
    text-align: left;
    .li {
      width: 384px;
      // height: 386px;
      height: 464px;
      border-radius: 14px;
      overflow: hidden;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      margin-bottom: 40px;
      display: inline-block;
      position: relative;
    }
    .margin24 {
      margin-right: 24px;
    }
    .competition-carousel-2 {
      width: 384px;
      height: 216px;
      margin-bottom: 85px;
      img {
        width: 384px;
        height: 216px;
      }
    }
    .title {
      width: 344px;
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      line-height: 33px;
      color: #000000;
      position: absolute;
      top: 236px;
      left: 0;
      padding-left: 20px;
      text-align: left;
      span {
        font-family: SourceHanSansSC-Medium;
      }
    }
    .margin {
      margin-right: 24px;
    }
    .level {
      padding: 0 10px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      border: 1px solid #0C59EF;
      border-radius: 4px;
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      height: 24px;
      line-height: 22px;
      color: #0C59EF;
    }
    .color1 {
      border: 1px solid #238E97;
      color: #238E97;
    }
    .color2 {
      border: 1px solid #493BC4;
      color: #493BC4;
    }
    .color3 {
      border: 1px solid #E7871E;
      color: #E7871E;
    }
    .color4 {
      border: 1px solid #e71ec2;
      color: #e71ec2;
    }
    .info {
      width: 344px;
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #666666;
      text-align: left;
      line-height: 20px;
      padding-left: 20px;
      margin-bottom: 20px;
      font-weight: 400;
    }
  }
  .more {
    padding: 96px 0 120px 0;
    button {
      height: 25px;
      line-height: 25px;
      font-family: SourceHanSansSC-Medium;
      font-size: 18px;
      color: #666666;
      background: none;
      cursor: pointer;
      position: relative;
      width: 105px;
      text-align: left;
    }
    i {
      color: #979797;
      position: absolute;
      top: 3px;
    }
    .i1 {
      right: 14px;
    }
    .i2 {
      opacity: .6;
      right: 7px;
    }
    .i3 {
      opacity: .4;
      right: 0;
    }
    button:hover {
      color: #0C59EF;
      i {
        color: #0C59EF;
      }
    }
  }
}
</style>
<style lang="less">
.show-carousel {
  .el-carousel__arrow {
    width: 60px;
    height: 60px;
    font-size: 30px;
  }
}
.competition-carousel-1 {
  .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #BDBDBD;
    border-radius: 8px;
    opacity: 1;
  }
  .is-active {
    .el-carousel__button {
      width: 20px;
      background: #0056F8;
    }
  }
}
.competition-carousel-2 {
  .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #BDBDBD;
    border-radius: 8px;
    opacity: 1;
  }
  .is-active {
    .el-carousel__button {
      width: 20px;
      background: #0056F8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applications/competition.vue